import variables from '../../../../style/variables.scss';

const images = require.context(
  '../../../../assets/imgs/03_wellnes/01_spa',
  true
);
const imageList: Array<string> = images
  .keys()
  .map((image: any) => images(image));

interface Feature {
  description: JSX.Element;
  imgPath: string;
}

const SPA: Feature = {
  description: (
    <>
      <h2 className='title_underline_complementary_small warning_text'>
        Time for booking:
      </h2>
      <p>
        <br />
        <i>Cornaro spa suite 25 min - 40€</i>
        <br />
        <br />
        <i>Cornaro spa suite 50 min - 60€</i>
        <br />
        <br />
        <i>Cornaro spa suite 80 min - 90€</i>
        <br />
        <br />
      </p>
      <h2 className='title_underline_complementary_small warning_text'>
        The special offer is valid:
      </h2>
      <p>
        <br />
        <i>For two persons</i>
        <br />
        <br />
        <i>For pre-booked 1 day before</i>
        <br />
        <br />
        <i>For the following period: 01.04.2026. - 31.10.2026.</i>
        <br />
        <br />
      </p>
      <p>
        Offer may not be used in conjunction with any other offers and is
        subject to availability.
      </p>
      <p>
        Offer is only valid when booking directly via{' '}
        <a
          href='https://cornarohotel.com/'
          style={{ color: variables.auxColor }}
          className='opacity_transition_low'
        >
          cornarohotel.com
        </a>{' '}
        or by e-mail{' '}
        <a
          href='mailto:booking@cornarohtel.com'
          style={{ color: variables.auxColor }}
          className='opacity_transition_low'
        >
          booking@cornarohtel.com
        </a>
        ,{' '}
        <a
          href='mailto:reservations@cornarohotel.com'
          style={{ color: variables.auxColor }}
          className='opacity_transition_low'
        >
          reservations@cornarohotel.com
        </a>{' '}
        <a
          href='mailto:cornarohotel.experience@cornarohotel.com'
          style={{ color: variables.auxColor }}
          className='opacity_transition_low'
        >
          cornarohotel.experience@cornarohotel.com
        </a>{' '}
      </p>
      <h2 className='title_underline_complementary_small warning_text'>
        CANCELLATION
      </h2>
      <p>
        To avoid penalty fees, please cancel 12 hours in advance. Any bookings
        canceled within 12 hours will be charged 50% of the cost of the booked
      </p>
      <h2 className='title_underline_complementary_small warning_text'>
        FOR MORE INFO:
      </h2>
      <p>
        <a
          href='mailto:reservations@cornarohotel.com'
          style={{ color: variables.auxColor }}
          className='opacity_transition_low'
        >
          reservations@cornarohotel.com
        </a>
        <br />
        <a
          href='mailto:spa@cornarohotel.com'
          style={{ color: variables.auxColor }}
          className='opacity_transition_low'
        >
          spa@cornarohotel.com
        </a>
        <br />
        <a
          href='tel:+385 21 644 200'
          style={{ color: variables.auxColor }}
          className='opacity_transition_low'
        >
          +385 21 644 200
        </a>
      </p>
    </>
  ),
  imgPath: imageList.find((x) => x.includes('spa')) || '',
};

const WellnessComponentList: Array<Feature> = [SPA];

export default WellnessComponentList;
